import { render } from "./PermissionTree.vue?vue&type=template&id=0908ce82"
import script from "./PermissionTree.vue?vue&type=script&lang=js"
export * from "./PermissionTree.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__